import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgTwitter = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M32.724 13.477q.019.42.02.85C32.744 22.997 26.14 33 14.064 33A18.6 18.6 0 0 1 4 30.053q.771.09 1.566.09a13.17 13.17 0 0 0 8.154-2.81 6.57 6.57 0 0 1-6.134-4.557 6.6 6.6 0 0 0 2.966-.114 6.565 6.565 0 0 1-5.266-6.434v-.084a6.5 6.5 0 0 0 2.974.822 6.563 6.563 0 0 1-2.032-8.764A18.64 18.64 0 0 0 19.76 15.06a6.565 6.565 0 0 1 11.186-5.987 13.1 13.1 0 0 0 4.17-1.591 6.6 6.6 0 0 1-2.886 3.631A13.2 13.2 0 0 0 36 10.08a13.4 13.4 0 0 1-3.276 3.397"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="m29.523 9.01-.293.063-.194-.23C27.776 7.358 26.022 6.5 24.15 6.5c-1.394 0-2.724.474-3.844 1.348l-.614-.79C20.985 6.052 22.53 5.5 24.15 5.5c2.073 0 4.015.903 5.445 2.467 1.46-.353 2.852-.961 4.13-1.8l1.13-.74-.376 1.298c-.565 1.955-1.771 3.625-3.375 4.691l-.553-.832a7.26 7.26 0 0 0 2.466-2.843 14 14 0 0 1-3.495 1.268M16.865 33.5c2.493 0 4.823-.401 6.965-1.175l.34.94c-2.252.814-4.698 1.235-7.305 1.235-3.998 0-7.828-1.14-11.134-3.25L3.9 30.081l2.158.251q.803.094 1.633.094c2.682 0 5.245-.764 7.44-2.169a7.59 7.59 0 0 1-5.735-5.104l.951-.306a6.59 6.59 0 0 0 6.156 4.556l1.41.026-1.111.868a14.74 14.74 0 0 1-8.748 3.124 19.6 19.6 0 0 0 8.811 2.079"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgTwitter);

export default ForwardRef;
